module.exports = __webpack_public_path__ + "static/media/dog.f738a00f.svg";